import { CustomStorageProvider } from './../providers/custom-storage/custom-storage';
import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild } from '@angular/core';
import { Platform, Config, Events, App, ModalController, NavController, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

//import { TabsPage } from '../pages/tabs/tabs';
import { Constants } from '../util/Constants';
import { WebSocketService } from '../services/webSocketService';
import { Push, PushOptions, PushObject } from '@ionic-native/push';
import { Util } from '../util/Util';
import { FbConfig } from '../util/FbConfig';
import { Device } from '@ionic-native/device';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2';
import { KintipsInAppPurchaseProvider } from '../providers/kintips-in-app-purchase/kintips-in-app-purchase';
import { HotNews } from '../pages/common/inbox/interface/HotNews';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  //rootPage:any = TabsPage;
  //rootPage:any = "GridMenuPage";
  @ViewChild("kintipsNav") navCtrl: NavController;
  receiveVoucherEventSubscription: any;

  constructor(private platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
    public translateService: TranslateService, public customStorageService: CustomStorageProvider,
    config: Config, public events: Events, appCtrl: App, websocketService: WebSocketService,
    modalCtrl: ModalController, private push: Push, private device: Device, private alertCtrl: AlertController,
    private kintipsIap: KintipsInAppPurchaseProvider, private customStorageProvider: CustomStorageProvider) {
    platform.ready().then(() => {

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // Commented out the status bar
      // if (!this.platform.is('mobileweb')) {
      //   statusBar.styleDefault();
      //   splashScreen.hide();
      // }
      if (Util.isApp(this.platform)) {
        this.kintipsIap.init();
      }

      setTimeout(() => {
        splashScreen.hide();
      }, 1000);
      //statusBar.overlaysWebView(true);
      //statusBar.backgroundColorByHexString("#000000");
      let langName = customStorageService.get<string>(Constants.STORAGE_KEY_LANG);
      if (langName == null || langName == "") {
        customStorageService.set(Constants.STORAGE_KEY_LANG, Constants.LANG_ZH_TW);
        langName = Constants.LANG_ZH_TW;
      }
      translateService.setDefaultLang(langName);
      translateService.use(langName);
      Constants.LANG_NAME = langName;

      let unreadNewsCount = this.customStorageService.get<number>(Constants.STORAGE_KEY_UNREAD_NEWS_COUNT);
      if (unreadNewsCount == null) {
        this.customStorageService.set(Constants.STORAGE_KEY_UNREAD_NEWS_COUNT, 0);
      }

      this.events.subscribe(Constants.WS_CODE_BROADCAST_HOT_NEWS.toString(), () => {
        if (appCtrl.getActiveNavs() != null && appCtrl.getActiveNavs().length > 0 && appCtrl.getActiveNavs()[0].getActive().name != "InboxPage") {
          let unreadNewsCount = this.customStorageService.get<number>(Constants.STORAGE_KEY_UNREAD_NEWS_COUNT);
          unreadNewsCount++;
          this.customStorageService.set(Constants.STORAGE_KEY_UNREAD_NEWS_COUNT, unreadNewsCount);
        }
      });

      this.events.subscribe(Constants.WS_CODE_BROADCAST_RECEIVE_VOUCHER.toString(), (response) => {
        let hotNews:HotNews = response as HotNews;
        let lang = this.customStorageProvider.get(Constants.STORAGE_KEY_LANG);
        let sMsg: string = "";
        if (lang == Constants.LANG_EN) {
          sMsg = hotNews.text;
        } else if (lang == Constants.LANG_ZH_CN) {
          sMsg = hotNews.text_ZH_CN;
        } else if (lang == Constants.LANG_ZH_TW) {
          sMsg = hotNews.text_ZH_TW;
        }
        let alert = this.alertCtrl.create({
          title: this.translateService.instant("congratulations"),
          message: sMsg,
          cssClass: 'alertReceiveVouchers',
          buttons: [
            {
              text: this.translateService.instant("goToHorseTips"),
              handler: () => {
                this.navCtrl.push("HorseHomeListTipsPage", {"selectedTab": 0});
              }
            },
            {
              text: this.translateService.instant("goToBallTips"),
              handler: () => {
                this.navCtrl.push("HorseHomeListTipsPage", {"selectedTab": 1});
              }
            },
            {
              text: this.translateService.instant("ok")
            }
          ]

        });
        alert.present();
      });

      // if (Util.isApp(platform)) {
      //   this.deploy.getSnapshots().then(snapshots => {
      //     console.log('Snapshots: ' + snapshots);
      //     this.deploy.info().then(x => {
      //       console.log('Current snapshot info: ' + x);
      //       for (let suuid of snapshots) {
      //         if (suuid !== x.deploy_uuid) {
      //           this.deploy.deleteSnapshot(suuid);
      //         }
      //       }
      //     });
      //   });

      //   this.deploy.check().then((snapshotAvailable: boolean) => {
      //     if (snapshotAvailable) {
      //       let modal = modalCtrl.create("UpdateAppPage", {}, {enableBackdropDismiss : false});
      //       modal.present();
      //     }
      //   });
      // }

      this.platform.pause.subscribe(() => {
        websocketService.destroy("pause");
      });

      this.platform.resume.subscribe(() => {
        websocketService.resetPaused();
        websocketService.connectWS();
      });

      this.navCtrl.setRoot("GridMenuPage").then(success => {
        if (!success) {
          if (this.navCtrl == null || this.navCtrl.getActive() == null || this.navCtrl.getActive().id != "login") {
            this.navCtrl.setRoot("StartUpPage");
          }
        }
      }).catch(err => { console.log(err) });

      console.log("app.component.ts");
      // this.pushsetup();
      // if (Util.isApp(this.platform)) {
      //   console.log("app.component.ts Is App");
      //   // init push options
      //   const options: PushOptions = {
      //     android: {
      //       senderID: '83662625039'
      //     },
      //     ios: {
      //       senderID: '83662625039',
      //       gcmSandbox: FbConfig.DEBUG,
      //       alert: 'true',
      //       badge: true,
      //       sound: 'true'
      //     },
      //     windows: {}
      //   };

      //   const pushObject: PushObject = this.push.init(options);

      //   pushObject.on('notification').subscribe((notification: any) => console.log('Received a notification', notification));
      // }
    });
  }

  pushsetup() {
    console.log("Is Push set up");
    const options: PushOptions = {
      android: {
        senderID: '83662625039'
      },
      ios: {
        senderID: '83662625039',
        gcmSandbox: FbConfig.DEBUG,
        alert: 'true',
        badge: true,
        sound: 'true'
      },
      windows: {}
    };

  const pushObject: PushObject = this.push.init(options);

  pushObject.on('notification').subscribe((notification: any) => {
    console.log("Received push notification" + notification);
    if (notification.additionalData.foreground) {
      let youralert = this.alertCtrl.create({
        title: 'New Push notification',
        message: notification.message
      });
      youralert.present();
    }
  });

  pushObject.on('registration').subscribe((registration: any) => {
    console.log("[Push Notification Registration] ok", registration);
     //do whatever you want with the registration ID
  });

  pushObject.on('error').subscribe(error => alert('Error with Push plugin' + error));
  }
}

/*
@Pipe({
  name: 'sort'
})
export class SortPipe {
  transform(array: Array<string>, args: string): Array<string> {
    array.sort((a: any, b: any) => {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
*/



// WEBPACK FOOTER //
// ./src/app/app.component.ts